<section class="otherApps section-pd-sm">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title text-center">
                    <h3 class="text-white">{{ title }}</h3>
                </div>
                <ul>
                    <li *ngFor="let app of appsList" [class]="app.class">
                      <a [routerLink]="[app.route]">
                        <div class="app_name_content_overlay"></div>
                        <img [src]="app.imgSrc" width="60" height="60" [alt]="app.imgAlt">
                        <h3>
                          {{ app.title }}
                          <small *ngIf="app.subtitle">{{ app.subtitle }}</small>
                        </h3>
                      </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>